export default __webpack_public_path__ + "static/media/performanceBlurredPlatformStats2.40906f4f.png";